import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { themeGet } from 'styled-system';
import { Icon, Box } from 'roo-ui/components';

const defaultTransition = themeGet('transitions.default');
const collapseTransition = themeGet('transitions.delayedCollapse');

const Button = styled.button`
  padding: ${themeGet('space.3')};
  margin: ${themeGet('space.2')};
  border: 1px solid;
  border-radius: 50%;
  transition: border-color ${defaultTransition}, background ${defaultTransition}, padding ${collapseTransition},
    margin ${collapseTransition};

  ${Icon} {
    transition: color ${defaultTransition};
  }

  ${(props) =>
    props.selected
      ? css`
          border-color: ${themeGet('colors.brand.primary')(props)};
          background: ${themeGet('colors.brand.primary')(props)};

          ${Icon} {
            color: ${themeGet('colors.white')(props)};
          }
        `
      : css`
          border-color: ${themeGet('colors.greys.alto')(props)};
          background: ${themeGet('colors.white')(props)};

          ${Icon} {
            color: ${themeGet('colors.greys.steel')(props)};
          }
        `}

  &:disabled {
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    cursor: pointer;
    border-color: ${themeGet('colors.brand.primary')};

    ${Icon} {
      color: ${themeGet('colors.brand.primary')};
    }
  }
`;

export const RatingButton = ({ name, selected, disabled, onClick }) => (
  <Button selected={selected} disabled={disabled} onClick={onClick}>
    <Icon name={name} size={21} />
  </Button>
);

export const RatingWrapper = styled(Box)`
  opacity: 1;
  height: auto;
  max-height: 240px;
  transition: all ${collapseTransition};

  &.disabled {
    opacity: 0;
    max-height: 0;
    padding: 0;
    margin: 0;
  }

  &.hidden {
    display: none;
  }
`;

RatingWrapper.displayName = 'RatingWrapper';
